import { GetStandardReturnHistoryAPIParameter, StandardReturnOrder } from "@dana/Services/StandardReturnStatusService";
import StandardReturnHistoryState from "@dana/Store/Data/StandardReturnsStatus/StandardReturnsStatusState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { PaginationModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: StandardReturnHistoryState = {
    isLoading: false,
   
    standardReturns: [],
    pagination: {} as any,
    filter: { sortBy: "DateOrdered", sort: "DESC", page: 1, pageSize: 12 }
};

const StandardReturnsHistoryStateImmerReducer = createTypedReducerWithImmer(initialState, {
    "StandardReturnsHistory/Init": (draft: Draft<StandardReturnHistoryState>, action: { isLoading: boolean }) => {
        draft = { ...initialState, isLoading: action.isLoading };
        return draft;
    },
    "StandardReturnsHistory/IsLoading": (draft: Draft<StandardReturnHistoryState>, action: { isLoading: boolean }) => {
        draft = { ...draft, isLoading: action.isLoading };
        return draft;
    },
    "StandardReturnsHistory/UpdateFilter": (draft: Draft<StandardReturnHistoryState>, action: { filter: GetStandardReturnHistoryAPIParameter }) => {
        draft = { ...draft, filter: action.filter };
        return draft;
    },
    "StandardReturnsHistory/LoadData": (draft: Draft<StandardReturnHistoryState>, action: { standardReturns: StandardReturnOrder[], pagination: PaginationModel }) => {

        draft = {
            ...draft,
            standardReturns: action.standardReturns,
            pagination: action.pagination,
        };
        return draft;
    },

});

(reducers as any).standardReturnsHistoryState = StandardReturnsHistoryStateImmerReducer;

type CreditStateReducers = {
    standardReturnsHistoryState: typeof StandardReturnsHistoryStateImmerReducer;
};

export type StandardReturnHistotyStateActions = Parameters<CreditStateReducers[keyof CreditStateReducers]>[1] | AnyAction;

